import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/logo/footer-logo.svg'


const _hoisted_1 = { class: "edu-footer-area" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer-top-area ptb-100" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4 col-md-6 col-sm-6" }
const _hoisted_6 = { class: "single-footer-widget" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "image"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<p> Lorem ipsum amet, consectetur adipiscing elit. Suspendis varius enim eros elementum tristique. Duis cursus. </p><ul class=\"social-links\"><li><a href=\"https://www.facebook.com/\" target=\"_blank\"><i class=\"bx bxl-facebook\"></i></a></li><li><a href=\"https://www.facebook.com/\" target=\"_blank\"><i class=\"bx bxl-twitter\"></i></a></li><li><a href=\"https://www.linkedin.com/\" target=\"_blank\"><i class=\"bx bxl-linkedin\"></i></a></li><li><a href=\"https://www.instagram.com/\" target=\"_blank\"><i class=\"bx bxl-instagram\"></i></a></li></ul>", 2)
const _hoisted_10 = { class: "col-lg-2 col-md-6 col-sm-6" }
const _hoisted_11 = { class: "single-footer-widget pl-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Links", -1)
const _hoisted_13 = { class: "links-list" }
const _hoisted_14 = { class: "col-lg-2 col-md-6 col-sm-6" }
const _hoisted_15 = { class: "single-footer-widget" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "Legal", -1)
const _hoisted_17 = { class: "links-list" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-4 col-md-6 col-sm-6\"><div class=\"single-footer-widget\"><h3>Newsletter</h3><div class=\"footer-newsletter-info\"><p> Join over <span>68,000</span> people getting our emails Lorem ipsum dolor sit amet consectet </p><form class=\"newsletter-form\" data-toggle=\"validator\"><label><i class=\"bx bx-envelope-open\"></i></label><input type=\"text\" class=\"input-newsletter\" placeholder=\"Enter your email address\" name=\"EMAIL\" required autocomplete=\"off\"><button type=\"submit\" class=\"default-btn\"><i class=\"bx bx-paper-plane\"></i> Subscribe Now </button></form></div></div></div>", 1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "pr-line" }, null, -1)
const _hoisted_20 = { class: "footer-bottom-area" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  target: "_blank"
}, "Edumim Template", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "logo"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Home")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("About Us")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Pricing")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Courses")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Contact Us")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Blog")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("ul", _hoisted_17, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Legal")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/about" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Tearms of Use")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/portfolio" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Tearm & Condition")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog-grid" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Payment Method")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/contact" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Privacy Policy")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/contact" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Privacy Policy")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _hoisted_18
        ])
      ]),
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("p", null, [
          _createTextVNode(" © Copyright " + _toDisplayString(_ctx.currentYear) + " | ", 1),
          _hoisted_21,
          _createTextVNode(" | All Rights Reserved is Proudly ")
        ])
      ])
    ])
  ]))
}